module.exports = __webpack_public_path__ + "img/qd-img-9.b1f7c94d.png";